import React from 'react';
import { Link } from 'gatsby';
import { WebsiteImage } from 'components/TitleDescription';
import rightArrow from '../../../images/right-arrow-gray.svg';

import {
  StyledHero,
  PlaybookDetailsContainer,
  PlaybookDetailsHeroTitle,
  PlaybookDetailsHeroKicker,
  PlaybookDetailsNavigation,
  SectionNavigation,
  PlaybookDetailsHeroSubhead,
  PlaybookDetailsReturn,
} from '../styles';

const PlaybookDetailsHero = ({
  splashPageSlug,
  title,
  description,
  sectionInfo,
  sections,
  playbookHeroBG,
}) => {
  const { current_section, current_chapter, total_chapters, total_sections } = sectionInfo;
  return (
    <StyledHero playbookHeroBG={playbookHeroBG}>
      <PlaybookDetailsReturn>
        <Link to={`/toolbox`}>
          Toolbox
          <WebsiteImage
            src={rightArrow}
            alt="playbook-back-btn"
            style={{ width: '12px', margin: '0 10px' }}
          />{' '}
        </Link>
        <Link to={`/${splashPageSlug}`} state={{ finishedChapter: current_chapter }}>
          Playbook
          <WebsiteImage
            src={rightArrow}
            alt="playbook-back-btn"
            style={{ width: '12px', margin: '0 10px' }}
          />{' '}
        </Link>
        <Link to={`/toolbox`} state={{ finishedChapter: current_chapter }}>
          Chapter {current_chapter + 1}
        </Link>
      </PlaybookDetailsReturn>
      <PlaybookDetailsContainer className="hero-content-conatiner">
        <PlaybookDetailsHeroKicker>CHAPTER {current_chapter + 1}</PlaybookDetailsHeroKicker>
        <PlaybookDetailsHeroTitle fontSize="normal">{title}</PlaybookDetailsHeroTitle>
        <PlaybookDetailsHeroSubhead fontSize="normal">{description}</PlaybookDetailsHeroSubhead>
      </PlaybookDetailsContainer>
      <PlaybookDetailsNavigation id="playbook-hero-nav">
        <Link
          to={current_section !== 0 && `/${splashPageSlug}/${sections[current_section - 1].slug}`}
        >
          <SectionNavigation
            disabled={current_section === 0}
            type="white"
            shadow={false}
            type={'secondary'}
            button
          >
            Previous
          </SectionNavigation>
        </Link>
        <Link
          to={
            current_section + 1 === total_sections
              ? `/${splashPageSlug}#${`chapter${current_chapter + 1}`}`
              : `/${splashPageSlug}/${sections[current_section + 1].slug}`
          }
          state={{ finishedChapter: current_chapter + 1 }}
        >
          <SectionNavigation type="secondary" button>
            {current_section + 1 === total_sections ? 'Finish Chapter' : 'Next Section'}
          </SectionNavigation>
        </Link>
      </PlaybookDetailsNavigation>
    </StyledHero>
  );
};

export default PlaybookDetailsHero;
